<template>
	<v-dialog
		:value="value"
		persistent
		:max-width="480"
		content-class="chunk-error-modal-dialog"
	>
		<v-card>
			<v-card-title class="headline modal-title">
				<v-icon :color="iconColor" size="32" class="mr-3">{{
					titleIcon
				}}</v-icon>
				{{ titleText }}
			</v-card-title>
			<v-card-text class="modal-content">
				<v-icon class="wifi-bg-icon" size="120" color="#F5F5F5">{{
					backgroundIcon
				}}</v-icon>
				<div class="error-message">
					<p class="error-main">{{ mainMessage }}</p>
					<p class="error-action">{{ actionMessage }}</p>
				</div>
				<div v-if="mode === 'reload'" class="wifi-waves">
					<div class="wave-source wave-source-1">
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div class="wave-source wave-source-2">
						<span></span>
						<span></span>
						<span></span>
					</div>
					<div class="wave-source wave-source-3">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</v-card-text>
			<v-card-actions class="modal-actions">
				<v-btn
					color="com1Color"
					style="font-size: 1rem"
					@click="onConfirm"
					large
					block
				>
					{{ buttonText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'ChunkErrorModal',
	props: {
		value: {
			required: true,
			type: Boolean,
		},
		mode: {
			type: String,
			default: 'reload',
			validator: v => ['reload', 'exhausted'].includes(v),
		},
	},
	computed: {
		isExhausted() {
			return this.mode === 'exhausted'
		},
		titleIcon() {
			return this.isExhausted ? 'mdi-alert-circle' : 'mdi-wifi-alert'
		},
		iconColor() {
			return this.isExhausted ? 'warning' : 'info'
		},
		backgroundIcon() {
			return this.isExhausted ? 'mdi-alert' : 'mdi-wifi'
		},
		titleText() {
			return this.isExhausted ? '載入失敗' : '網路連線不穩定'
		},
		mainMessage() {
			return this.isExhausted
				? '已多次嘗試重新載入，仍無法成功取得最新資源'
				: '偵測到網路連線不太穩定，可能會影響您的操作'
		},
		actionMessage() {
			return this.isExhausted
				? '請手動關閉此分頁後重新打開，或聯絡客服協助'
				: '請點擊下方按鈕重新載入頁面，確保一切正常運作'
		},
		buttonText() {
			return this.isExhausted ? '我知道了' : '重新整理'
		},
	},
	methods: {
		onConfirm() {
			this.$emit('onConfirm')
		},
	},
}
</script>

<style lang="scss" scoped>
.chunk-error-modal-dialog {
	& > .v-card {
		border-radius: 16px;
		box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

		.v-card__title.modal-title {
			width: 100%;
			font-size: 1.5rem !important;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: bold;
			padding: 32px 32px 16px 32px;
			text-align: center;
		}

		.v-card__text.modal-content {
			padding: 8px 32px 24px 32px;
			position: relative;
			overflow: hidden;

			.wifi-bg-icon {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				opacity: 0.08;
				z-index: 0;
			}

			.wifi-waves {
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				left: 0;
				pointer-events: none;
				z-index: 1;

				.wave-source {
					position: absolute;

					&.wave-source-1 {
						top: 20%;
						left: 25%;
					}

					&.wave-source-2 {
						top: 60%;
						right: 20%;
					}

					&.wave-source-3 {
						bottom: 25%;
						left: 40%;
					}

					span {
						position: absolute;
						border: 2px solid #e0e0e0;
						border-radius: 50%;
						opacity: 0;
						transform: translate(-50%, -50%);

						&:nth-child(1) {
							width: 40px;
							height: 40px;
							animation: wifi-pulse 3s infinite;
							animation-delay: 0s;
						}

						&:nth-child(2) {
							width: 80px;
							height: 80px;
							animation: wifi-pulse 3s infinite;
							animation-delay: 1s;
						}

						&:nth-child(3) {
							width: 120px;
							height: 120px;
							animation: wifi-pulse 3s infinite;
							animation-delay: 2s;
						}
					}
				}

				@keyframes wifi-pulse {
					0% {
						opacity: 0.6;
						transform: translate(-50%, -50%) scale(0.5);
					}
					50% {
						opacity: 0.3;
					}
					100% {
						opacity: 0;
						transform: translate(-50%, -50%) scale(1.2);
					}
				}
			}

			.error-message {
				font-size: 1rem;
				line-height: 1.6;
				color: #424242;
				text-align: center;
				position: relative;
				z-index: 2;

				.error-main {
					margin: 0 0 16px 0;
					padding: 0;
					font-size: 1.1rem;
					color: #616161;
					font-weight: 500;
					letter-spacing: 0.3px;
				}

				.error-action {
					margin: 0;
					padding: 0;
					font-size: 0.95rem;
					color: #757575;
					line-height: 1.5;
					font-weight: 400;
				}
			}
		}

		.v-card__actions.modal-actions {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 32px 32px 32px;

			::v-deep .v-btn {
				height: 56px;
				font-weight: 500;
			}
		}
	}
}
</style>
